module.exports = __webpack_public_path__ + "static/media/h2.b1cb6406.svg";